var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "handing global-page-base-layout",
      attrs: { loading: _vm.loading },
    },
    [
      _c("Caseconditons", {
        on: { choose: _vm.checkList, cleanCondition: _vm.cleanConditionData },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "handing-all-btn" },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.multipleSelection.length <= 0 },
              on: { click: _vm.batchReview },
            },
            [_vm._v("批量发起组庭")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "handing-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                height: "calc(100vh - 410px)",
                "header-cell-style": { background: _vm.tableHeaderColor },
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "案号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.caseNo
                          ? _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.caseNo))]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "link-style",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row.caseId)
                                  },
                                },
                              },
                              [_vm._v("暂无案号")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "caseId", label: "受理号" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "registerApplyTime", label: "申请日期" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "appName", label: "申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "resName", label: "被申请人" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitrationReason", label: "案由" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "controversyAmount", label: "争议金额(元)" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "arbitrationAmount", label: "仲裁费(元)" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "state", label: "案件状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.caseState[scope.row.state]) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "handingSecretaryName", label: "办案秘书" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "registerSendTime", label: "立案时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "130", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "medium" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCheck(scope.row)
                              },
                            },
                          },
                          [_vm._v("【发起组庭】")]
                        ),
                        _vm._v(" "),
                        _c("br"),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": _vm.pageSizes,
                  "page-size": 10,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "compose-dialog",
          attrs: {
            title: "发起组庭",
            visible: _vm.divisionVisible,
            "close-on-click-modal": false,
            width: "900px",
            top: "8vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.divisionVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "info-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _c("i", { staticClass: "el-icon-user-solid" }),
                _vm._v(" "),
                _c("span", [_vm._v("仲裁员信息")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "arbitrator-grid" }, [
                _c("div", { staticClass: "arbitrator-item" }, [
                  _c("div", { staticClass: "arbitrator-label" }, [
                    _vm._v("申请人选定仲裁员"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "arbitrator-value" }, [
                    _vm.partyChoiceArb.appArbitratorName
                      ? _c("span", { staticClass: "arbitrator-name" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.partyChoiceArb.appArbitratorName) +
                              "\n              "
                          ),
                        ])
                      : _c("span", { staticClass: "no-data" }, [
                          _vm._v("未选定仲裁员"),
                        ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "arbitrator-item" }, [
                  _c("div", { staticClass: "arbitrator-label" }, [
                    _vm._v("被申请人选定仲裁员"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "arbitrator-value" }, [
                    _vm.partyChoiceArb.resArbitratorName
                      ? _c("span", { staticClass: "arbitrator-name" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.partyChoiceArb.resArbitratorName) +
                              "\n              "
                          ),
                        ])
                      : _c("span", { staticClass: "no-data" }, [
                          _vm._v("未选定仲裁员"),
                        ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _c("i", { staticClass: "el-icon-document" }),
                _vm._v(" "),
                _c("span", [_vm._v("答辩信息")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "defense-grid" }, [
                _c("div", { staticClass: "defense-item" }, [
                  _c("div", { staticClass: "defense-label" }, [
                    _vm._v("答辩状内容"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "defense-value" },
                    [
                      _vm.partyChoiceArb.content == ""
                        ? _c("span", { staticClass: "no-data" }, [
                            _vm._v("暂无答辩状"),
                          ])
                        : _c("el-input", {
                            staticClass: "disabled-textarea",
                            attrs: {
                              type: "textarea",
                              resize: "none",
                              rows: "4",
                              disabled: "",
                            },
                            model: {
                              value: _vm.partyChoiceArb.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.partyChoiceArb, "content", $$v)
                              },
                              expression: "partyChoiceArb.content",
                            },
                          }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "defense-item" }, [
                  _c("div", { staticClass: "defense-label" }, [
                    _vm._v("答辩材料"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "defense-value" },
                    [
                      _vm.partyChoiceArb.replyName == ""
                        ? _c("span", { staticClass: "no-data" }, [
                            _vm._v("暂无答辩材料"),
                          ])
                        : _c(
                            "el-link",
                            {
                              staticClass: "file-link",
                              attrs: {
                                type: "primary",
                                underline: false,
                                href: _vm.partyChoiceArb.href,
                                target: "_blank",
                                icon: "el-icon-document",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.partyChoiceArb.replyName) +
                                  "\n              "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "review-section" },
              [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-s-check" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("审核操作")]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "reviewForm",
                    staticClass: "review-form",
                    attrs: {
                      "label-width": "120px",
                      model: _vm.partyChoiceArb,
                      rules: _vm.divisionRules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "下一级审核人", prop: "secretaryId" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "form-select",
                            attrs: { placeholder: "请选择审核人" },
                            model: {
                              value: _vm.partyChoiceArb.secretaryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.partyChoiceArb, "secretaryId", $$v)
                              },
                              expression: "partyChoiceArb.secretaryId",
                            },
                          },
                          _vm._l(_vm.secretaryList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "经办意见", prop: "opinion" } },
                      [
                        _c("el-input", {
                          staticClass: "form-textarea",
                          attrs: {
                            type: "textarea",
                            rows: "3",
                            placeholder: "请填写经办意见",
                            resize: "none",
                            maxlength: "500",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.partyChoiceArb.opinion,
                            callback: function ($$v) {
                              _vm.$set(_vm.partyChoiceArb, "opinion", $$v)
                            },
                            expression: "partyChoiceArb.opinion",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      _vm.divisionVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.gotoServicing,
                    size: "medium",
                    icon: "el-icon-s-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.caseCourtAdopt()
                    },
                  },
                },
                [_vm._v("\n        进行组庭\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "process-dialog",
          attrs: {
            title: "批量审核",
            visible: _vm.processVisible,
            "close-on-click-modal": false,
            width: "600px",
            top: "15vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.processVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-form",
                {
                  ref: "opinionform",
                  staticClass: "batch-review-form",
                  attrs: {
                    "label-width": "120px",
                    rules: _vm.refuseRules,
                    model: _vm.opinionform,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "下一级审核人", prop: "reviewId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-select",
                          attrs: { placeholder: "请选择审核人" },
                          model: {
                            value: _vm.opinionform.reviewId,
                            callback: function ($$v) {
                              _vm.$set(_vm.opinionform, "reviewId", $$v)
                            },
                            expression: "opinionform.reviewId",
                          },
                        },
                        _vm._l(_vm.optionArr, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "经办意见", prop: "opinion" } },
                    [
                      _c("el-input", {
                        staticClass: "form-textarea",
                        attrs: {
                          type: "textarea",
                          rows: "6",
                          placeholder: "请输入经办意见",
                          resize: "none",
                          maxlength: "500",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.opinionform.opinion,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.opinionform,
                              "opinion",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "opinionform.opinion",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      _vm.processVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.loadingProcess,
                    size: "medium",
                    icon: "el-icon-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleProcess()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }